import {OccAssets, defaultOccAssets} from '@vista/omnichannel-components-ui/lib/src/lib/context/occ/types/assets'

import { Assets } from '../types'
import { NestedPartial } from '@vista/omnichannel-components-domain'

export interface GetAssetsDataProps {
    assets?:NestedPartial<Assets>
}

export function getAssetsData(props:GetAssetsDataProps):OccAssets {
    const {assets} = props
    return {
        ...defaultOccAssets,
        componentErrorIconName: assets?.componentErrorIconName || defaultOccAssets.componentErrorIconName,
        passwordInputHiddenIconName: assets?.passwordInputHiddenIconName || defaultOccAssets.passwordInputHiddenIconName,
        passwordInputVisibleIconName: assets?.passwordInputVisibleIconName || defaultOccAssets.passwordInputVisibleIconName,
        carouselNextButtonIconName: 'arrow-right',
        carouselPreviousButtonIconName: 'arrow-left',
    }
}